import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { FormGroupType } from '../../../../../../../../core/models/form-group-type';
import { ApplicationStateService } from '../../../../../../shared/services/application-state/application-state.service';
import { ScheduleDFormModel } from '../../../../models/schedule-d-form-model';
import { ScheduleDFormService } from '../../../../services/schedule-d-form/schedule-d-form.service';
import { ScheduleDBinaryLocationType } from '../../../../types/schedule-d-binary-location-type';
import { ScheduleDStepControlsMap } from '../../../../types/schedule-d-step-controls-map';
import { ScheduleDStepBaseService } from '../../../shared/services/schedule-d-step-base.service';

@Injectable({
    providedIn: 'root',
})
export class ScheduleDStepThreeService extends ScheduleDStepBaseService<ScheduleDBinaryLocationType> {
    override stepControlMap: ScheduleDStepControlsMap<ScheduleDBinaryLocationType> =
        {
            fixed: [
                'siteStatus',
                'quietZoneNotificationDate',
                'quietZoneConsent',
                'nepa',
                'mexicoClearanceIndicator',
            ],
            'non-fixed': [
                'siteStatus',
                'clearanceIndicator',
                'nepa',
                'mexicoClearanceIndicator',
            ],
        };

    constructor() {
        super(inject(ScheduleDFormService), inject(ApplicationStateService));
    }

    override isStepValid(
        form: FormGroup<FormGroupType<ScheduleDFormModel>>,
    ): Observable<boolean> {
        return this.formService.isFormValidForLocationType(form);
    }

    override getLocationType(
        form: FormGroup<FormGroupType<ScheduleDFormModel>>,
    ): ScheduleDBinaryLocationType {
        return this.formService.getBinaryLocationType(form);
    }

    /**
     * Returns whether the form should show a field based on the type of schedule d.
     * @param field the field to check.
     * @returns true if the form should show the field, otherwise false.
     */
    canHaveField(
        form: FormGroup<FormGroupType<ScheduleDFormModel>>,
        field: keyof ScheduleDFormModel,
    ): boolean {
        return this.stepControlMap[this.getLocationType(form)].includes(field);
    }
}
